
<mat-card id="create-securities-by-custom-dialog-component">

  <mat-card-content>
    <div class="dblock">
      You can define a custom security by creating your own symbol, which can be used to represent a non exchange-traded<br/>
      security (e.g. real estate or an SMA) or a group of securities (such as similar bonds).
    </div>

    <div class="dblock upperblock">
      <div class="left" style="line-height: 22px">Custom security
        <span class="tooltipIconLeft infoIcon trade-explanation-icon" style="display: inline-block;"
        calltoaction [calltoactionTemplate]="customSecurityToolTipIcon"></span></div>
        <div class="left" style="margin: 0 20px 0 22px;">
          <input id="securitySymb" regExp='[^%,?&" ]{1,25}' type="text" pInputText placeholder="-Enter Symbol-"
            onfocus="this.placeholder = ''" onblur="this.placeholder = '-Enter Symbol-'"
            [(ngModel)]="securitySymb" maxLength="25" (keyup)="onKeyUpChange()" spellcheck="false"/>
          @if (tooltipMessageSucessShow) {
            <p class="tooltip-message-sucess-title">{{tooltipMessageSucess}}</p>
          }
          @if (!tooltipMessageSucessShow) {
            <p class="tooltip-message-title">{{tooltipMessage}}</p>
          }
        </div>
        <div class="left" style="display: inline-block; position: relative;">
          <button id="addButton" class="btn-medium-secondary"  [disabled]="checkAvailability" (click)="checkSecurities()" >Check availability
          </button>
        </div>
        <br class="clear"/>
      </div>
      <div class="block">
        <div class="left" style="line-height: 22px">Security type*</div>
        <div class="left"  style="margin: 0 20px 0 52px;">
          <span id="securityTypeDropdown">
            <irb-dropdown-filter
              #securityTypeDropdown
              [(value)]="selectedSecurityType"
              (search)="getItemsForSecurityTypeDropdown($event)"
              (selection)="onSecurityTypeChanged($event)"
              [disabled]="isOtherInputsDisable"
              hoverPanelWidth="175"
              size="15">
            </irb-dropdown-filter>
          </span>
        </div>
        @if (isExternalShare) {
          <div class="left">External share price  $ :   </div>
        }
        @if (isExternalShare) {
          <div class="left" >
            <irb-number-text-box #shareprice invalidMessage="The value entered is not valid." [(ngModel)]="externalSharePrice"
              [(value)]="externalSharePrice" min="0" max="999999999" places="2"
              invalidRangeMessage="Please enter only numbers between 0 and 999999999." [disabled]="isOtherInputsDisable"
            ></irb-number-text-box>
          </div>
        }
        <br class="clear"/>
      </div>

      <div class="block">
        <div class="left" style="line-height: 22px">Security description</div>
        <div class="left" style="margin: 0 30px 0 20px;">
          <input id="securitySymbDesc" type="text" pInputText class="securitySymbDesc"
            placeholder="-Enter Description (Optional)-"
            onfocus="this.placeholder = ''" onblur="this.placeholder = '-Enter Description (Optional)-'"
            [(ngModel)]="securitySymbDesc"
            maxLength="50" [disabled]="isOtherInputsDisable" />
          </div>
          <br class="clear"/>
        </div>
        <div>
          <div class="left" style="line-height: 22px">{{customCategoryLabel}}</div>
          <div class="left" style="margin: 0 20px 0 98px;">
            <span id="assetCustomCategoryDropdown">
              <irb-dropdown-filter
                #customCategoriesDropdown
                [(value)]="selectedCustomCategory"
                (search)="getItemsForCustomCategoriesDropdown($event)"
                (selection)="onCustomCategoryChanged($event)"
                [disabled]="isOtherInputsDisable"
                hoverPanelWidth="200"
                size="20">
            </irb-dropdown-filter>
          </span>
        </div>
        <br class="clear"/>
      </div>
    </mat-card-content>
  </mat-card>


  <mat-dialog-actions>
    <button id="closeButton" (click)="close()" class="btn-medium-secondary">Cancel</button>
    <button id="continueButton" (click)="addSecurity()" class="btn-medium-primary" [disabled]="canNotContinue">Continue</button>
  </mat-dialog-actions>
  <ng-template #customSecurityToolTipIcon>
    Consider beginning your custom symbol with a
    character not used in exchange-traded ticker symbol,
    such as:~ Tilde; ! Exclamation point; or # Hash; Up to 2
    special characters can be used in a custom security
    symbol.
  </ng-template>
